import { ReactElement, useState } from "react";
import { Button } from "@justworkshr/milo-core";

import {
  QR_KEY_CODE_INSTRUCTION_COPY,
  QR_KEY_CODE_LINK_COPY,
} from "../../../constants/factorCopy";

import styles from "./secret-key.module.css";

const SecretKey = ({
  secretKey,
}: {
  secretKey: string | undefined;
}): ReactElement => {
  const [isSecretShowing, setIsSecretShowing] = useState<boolean>(false);

  return (
    <div className={styles.container}>
      {isSecretShowing ? (
        <>
          <div>{QR_KEY_CODE_INSTRUCTION_COPY}</div>
          <div className={styles.secretKey}>{secretKey}</div>
        </>
      ) : (
        <div className={styles.buttonContainer}>
          {!!secretKey && (
            <Button
              type="button"
              variant="ghost"
              onClick={() => setIsSecretShowing(true)}
            >
              {QR_KEY_CODE_LINK_COPY}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default SecretKey;
